import { useEffect, useMemo, useState } from "react"

export default function ProgressBar({
  complete
}: {
  complete: Record<string, boolean>
}) {
  const sections = useMemo(
    () => [
      { label: "Trademark", short: "Trademark", icon: "/TM.svg", target: "trademark" },
      { label: "Goods & Services", short: "Goods", icon: "/warenunddienstleistungen.svg", target: "goods" },
      { label: "Applicant & Representative", short: "Applicant", icon: "/anmeldervertreter.svg", target: "applicant" },
      { label: "Signature", short: "Signature", icon: "/unterschrift.svg", target: "signature" },
      { label: "Payment", short: "Payment", icon: "/zahlungsverfahren.svg", target: "payment" }
    ],
    []
  )

  const [hoveredSection, setHoveredSection] = useState<string | null>(null)

  useEffect(() => {
    const cleanups: Array<() => void> = []

    sections.forEach(({ target }) => {
      const element = document.getElementById(target)
      if (!element) return

      const enter = () => setHoveredSection(target)
      const leave = () =>
        setHoveredSection(curr => (curr === target ? null : curr))

      element.addEventListener("mouseenter", enter)
      element.addEventListener("mouseleave", leave)

      cleanups.push(() => {
        element.removeEventListener("mouseenter", enter)
        element.removeEventListener("mouseleave", leave)
      })
    })

    return () => {
      cleanups.forEach(fn => fn())
    }
  }, [sections])

  // methode zum scrollen beim klicken in der leiste
  const handleScroll = (targetId: string) => {
    const element = document.getElementById(targetId)
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }

  return (
    <div className="flex justify-between items-center w-full px-2 sm:px-10 mt-4">
      {sections.map(({ label, short, icon, target }) => {
        const isHover = hoveredSection === target
        const isComplete = Boolean(complete[target])

        return (
          <div
            key={target}
            onClick={() => handleScroll(target)}
            onMouseEnter={() => setHoveredSection(target)}
            onMouseLeave={() =>
              setHoveredSection(curr => (curr === target ? null : curr))
            }
            title={label}
            className={`inline-flex items-center gap-2 h-9 px-2 lg:px-3 rounded-md cursor-pointer select-none
              transition-colors duration-200 ease-in-out
              ${
                isHover
                  ? "bg-green-100"
                  : "text-gray-700 hover:bg-green-50 hover:text-green-700 active:bg-green-200"
              }`}
          >
            {/* abschnitts-icon, bei abgeschlossenem abschnitt mit kleinem grünen haken */}
            <span className="relative shrink-0">
              <img src={icon} alt={label} className="w-5 h-5 brightness-0" />
              {isComplete && (
                <span className="absolute -bottom-1 -right-1 flex h-3.5 w-3.5 items-center justify-center rounded-full bg-green-600 text-white">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-2.5 w-2.5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={4}
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </span>
              )}
            </span>

            {/* text des jeweiligen abschnitts */}
            <span className="hidden lg:inline text-sm font-medium leading-none">
              {short}
            </span>
          </div>
        )
      })}
    </div>
  )
}
